<template lang="html">
	<b-overlay :show = "isLoading" opacity="1" no-wrap></b-overlay>
</template>

<script>
export default {
	props: ['isLoading']
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/views/Manager/Shared/BaseOverlay.vue